import { createContact, updateContact } from '../../providers/api/contact/contactProvider';
import { Contact } from '../../providers/api/dtos';
import { mergeContact } from './mergeContact';

export default async function createOrUpdateContact(newContactValues?: Partial<Contact>, existingContact?: Contact): Promise<Contact> {
  if (!newContactValues && !existingContact) {
    throw new Error('One of values or existingContact parameter is mandatory.');
  }

  if (newContactValues && !existingContact?.id) {
    const contact = await createContact(newContactValues);

    return contact;
  }

  if (existingContact?.id && newContactValues) {
    const contact = await updateContact(existingContact.id!, mergeContact(existingContact, newContactValues));

    return contact;
  }

  return Promise.resolve(existingContact!);
}
